import React from 'react';
import PropTypes from 'prop-types';

import ErrorBoundary from 'components/ErrorBoundary';
import AppErrorFallback from 'views/_app/AppErrorFallback';
import SentryRoute from './SentryRoute';

const Route = (props) => {
  const { location } = props;

  return (
    <ErrorBoundary
      fallback={<AppErrorFallback Layout={null} />}
      location={location}
    >
      <SentryRoute {...props} />
    </ErrorBoundary>
  );
};

Route.propTypes = {
  location: PropTypes.object,
};

export default Route;
